import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { showClient, editClient, createClient } from '../../controllers/api_clients'; // Importa el servicio
import { getTypeTaxpayer } from '../../controllers/api_type_taxpayer'; // Importa el servicio
import { useNavigate } from "react-router-dom"; // Para la redirección
import { decryptText } from '../../controllers/api'; // Importa el servicio para encriptar/desencriptar parametros
import { useLocation } from "react-router-dom"; // Para la obtener el parametro de la url
import { toast, ToastContainer } from "react-toastify"; // Importamos las funciones necesarias
import "react-toastify/dist/ReactToastify.css"; // Importar el CSS de las notificaciones
import $ from "jquery";
import {
  validateFormatEmail,
  validateFormatPhone,
  contarDigitosDocumento,
  esFirmaPersonal,
  mapearCat7,
  validarLongitudCat7,
  validarCoherenciaRifCat7,
  validarFormatoRifCat7,
} from "../../utils/formatters";
// (2026-08-02, ítem 21) Buscador del emisor (padre): mismo patrón que
// FormWithholdings.js:803-824.
import { Autocomplete, TextField } from "@mui/material";
// (2026-08-02, ítem 18) Catálogo 7 (tipo de identificación) desde el endpoint
// PÚBLICO /api/catalogos/tipo-identificacion.
import { getCatalogoPublico } from "../../controllers/apiSeniat";
import LogoUploader from "../../components/LogoUploader/LogoUploader";
import { getClients, normalizeClientsResponse } from "../../controllers/api_clients"; // Req 1
import { getMonedas, normalizeMonedasResponse } from "../../controllers/api_monedas"; // Req 2
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";
import { preventEnterSubmit, FORM_FOOTER_CONTAINER, FORM_BTN_CANCEL, FORM_BTN_SUBMIT } from "../../utils/formHelpers";
import CorrelativosFiscales from "./CorrelativosFiscales";

function FormClients({ mode = 'clientes' }) {
  // (2026-05-15) Modo terceros: el operador_admin crea/edita SUS terceros.
  // Se fuerza es_tercero=true y padre_id = cliente del usuario (su emisor),
  // se ocultan los selectores de tipo y se navega bajo /terceros.
  const isTerceros = mode === 'terceros';
  const { user } = useContext(AuthContext);
  // Req 1 v2 (2026-05-13): excluir al propio cliente del operador (y al
  // cliente "Admin" interno) del listado de emisores disponibles. Un admin
  // no factura a su propia empresa, ni un operador puede ser su propio padre.
  const ownClienteId = user?.empresa_id;
  const navigate = useNavigate(); // Hook para redirección
  // Obtener los query parameters con `useLocation`
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get("id"); // Obtener el ID de la URL
  const [client, setClient] = useState(null);
  const [typeTaxpayer, setTypeTaxpayer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [errors, setErrors] = useState({}); // Estado para errores de validación
  const [emisoresDisponibles, setEmisoresDisponibles] = useState([]); // Req 1: dropdown padre_id
  const [monedas, setMonedas] = useState([]); // Req 2: catalogo de monedas
  // Req 1 v5 (2026-05-13): archivo de contrato opcional al crear un tercero.
  // No se persiste en el estado `client` para no contaminar el PUT/POST con
  // un File serializado raro; se inyecta como base64 solo en el momento de
  // crear (handleSubmit).
  const [contratoFile, setContratoFile] = useState(null);
  // (2026-08-02, ítem 18) Catálogo 7: opciones { id, codigo, descripcion,
  // es_rif, label } y aviso VISIBLE si el catálogo llegó degradado.
  const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
  const [catalogoAviso, setCatalogoAviso] = useState(null);
  // (2026-05-22) Ref a la sección de correlativos fiscales. Su guardado
  // está unificado con el del formulario: tras crear/actualizar la
  // empresa se invoca correlativosRef.current.guardar(empresaId).
  const correlativosRef = useRef(null);
  // (2026-08-02, remediación FE-A P1-4) Bloqueo reportado por la sección de
  // correlativos (carga en curso o fallida). Mientras esté activo NO se puede
  // enviar el formulario: un submit en ese estado guardaría los valores por
  // defecto y RETROCEDERÍA la numeración fiscal real de la empresa.
  const [correlativosBloqueo, setCorrelativosBloqueo] = useState(null);

  // Simulando la carga de datos del client por el ID
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const datattp = await getTypeTaxpayer();
        //console.log('datattp: ', datattp);
        setTypeTaxpayer(datattp);
        if (clientId != null){
          const data = await showClient(decryptText(clientId)); // Llamamos a showClient con el ID
          //console.log('data: ', data);
          setClient(data); // Guardamos los datos del client en el estado
        }else{
          setClient({
            id: "#",
            rif: "",
            nombre_empresa: "",
            telefono: "",
            email: "",
            region: "",
            estado: "",
            zona: "",
            direccion: "",
            tipo_contribuyente_id: 1,
            // Req 1 (2026-05-13): facturación de terceros
            // (2026-05-15) En modo terceros se fuerza es_tercero=true y el
            // padre = cliente del usuario (su emisor) automáticamente.
            es_emisor: false,
            es_tercero: isTerceros ? true : false,
            padre_id: isTerceros ? (ownClienteId || null) : null,
            // comision_servicio NO se setea aquí — backend lo deja en 0.00
            // para terceros y NULL para no-terceros. Se actualiza al aprobar
            // el contrato del tercero.
            // (2026-05-20) regla_facturacion: solo aplica si es_emisor=true;
            // default 'Separada' (preserva comportamiento histórico).
            regla_facturacion: 'Separada',
            // (2026-06-10) regla_costo (Compras): cómo se actualiza el costo
            // de los productos al registrar compras. Default 'ultimo'.
            regla_costo: 'ultimo',
            // (2026-07-22 Viajes) D1 nivel 1: habilita el nodo `/viajes`
            // (agencias de viaje / boletería aérea) para esta empresa. Sin
            // esta marca el backend RECHAZA (400) cualquier documento que
            // envíe `viajes` o `es_boleteria_aerea=true`. Default false.
            es_agencia_viajes: false,
            // Req 2 (2026-05-13): moneda designada (VES=3) y extranjera (USD=1) por defecto.
            moneda_designada_id: 3,
            moneda_extranjera_id: 1,
            // (Increment 1C, Parte E/G) Modo de operación de la numeración fiscal.
            // Obligatorio (el backend lo exige al crear). Vacío -> validate() lo pide.
            // (2026-08-02, ítem 20) Para TERCEROS se HEREDA del emisor y el
            // campo queda bloqueado (empresa_routes.py:402-410).
            tipo_operacion: "",
            // (2026-08-02, ítems 17/18) FK a la fila del Catálogo 7. El backend
            // ya la acepta y valida contra la letra del RIF
            // (empresa_routes.py:421-423 -> validar_tipo_identificacion_empresa).
            tipo_identificacion_id: null,
          })
        }
        // (ítem 18) Catálogo 7 desde el endpoint PÚBLICO (sin rol): el agregado
        // /api/seniat/catalogos es admin/auditor-only y devolvía 403 al
        // operador_admin que gestiona sus terceros.
        try {
          const cat = await getCatalogoPublico('tipo-identificacion');
          const { opciones, aviso } = mapearCat7(cat);
          setTiposIdentificacion(opciones);
          setCatalogoAviso(aviso);
          if (aviso) toast.warn(aviso, { autoClose: 8000 });
        } catch (e) {
          console.warn("No se pudo cargar el Catálogo 7 (tipo de identificación).", e);
          const { opciones, aviso } = mapearCat7(null);
          setTiposIdentificacion(opciones);
          setCatalogoAviso(aviso);
          toast.warn(aviso, { autoClose: 8000 });
        }
        // Req 2: cargar catalogo de monedas activas para los selectores.
        try {
          const dataMon = await getMonedas({ activo: true });
          setMonedas(normalizeMonedasResponse(dataMon));
        } catch (e) {
          console.warn("No se pudo cargar el catalogo de monedas", e);
        }
        // Cargar emisores disponibles para popular el dropdown de padre_id
        // (solo si el rol puede crear terceros: admin/operador_admin).
        try {
          const emisores = await getClients({ es_emisor: true });
          setEmisoresDisponibles(normalizeClientsResponse(emisores));
        } catch (e) {
          // No bloqueante: si falla, el dropdown queda vacío.
          console.warn("No se pudieron cargar emisores para padre_id", e);
        }
      } catch (err) {
        setError('Error al cargar el cliente');
      } finally {
        setLoading(false); // Indicamos que la carga ha finalizado
      }
    };
    fetchClient();
  }, [clientId]); // Recarga si el `clientId` cambia

  // (2026-05-22) Regla de negocio: un TERCERO hereda OBLIGATORIAMENTE la
  // moneda extranjera de su empresa emisora (padre). El backend ya la
  // sobreescribe al crear/actualizar; aquí forzamos el valor en la UI
  // apenas se selecciona el emisor, para que el campo refleje lo que
  // realmente se persistirá. El selector de moneda extranjera queda
  // deshabilitado para cualquier tercero (ver `disabled` del <select>).
  useEffect(() => {
    if (!client) return;
    const esTercero = isTerceros || !!client.es_tercero;
    if (!esTercero || !client.padre_id) return;
    const emisor = (emisoresDisponibles || []).find(
      (em) => Number(em.id) === Number(client.padre_id)
    );
    if (
      emisor &&
      emisor.moneda_extranjera_id &&
      Number(emisor.moneda_extranjera_id) !== Number(client.moneda_extranjera_id)
    ) {
      setClient((prev) => ({
        ...prev,
        moneda_extranjera_id: Number(emisor.moneda_extranjera_id),
      }));
    }
  }, [client?.padre_id, client?.es_tercero, isTerceros, emisoresDisponibles]);

  // (2026-08-02, ítem 20) Un TERCERO hereda OBLIGATORIAMENTE el `tipo_operacion`
  // (modo de operación de la numeración fiscal) de su emisor: el backend lo
  // fuerza al crear y al editar e IGNORA el del payload
  // (empresa_routes.py:394-410, `_sincronizar_tipo_operacion_terceros` :272-283).
  // Calcado del useEffect de `moneda_extranjera_id` de arriba.
  //
  // En modo /terceros el padre es la empresa del usuario, que NO está en
  // `emisoresDisponibles` (el backend la excluye del dropdown): el valor se toma
  // del login, que desde esta ronda incluye `cliente.tipo_operacion`
  // (auth_routes.py:511-518).
  useEffect(() => {
    if (!client) return;
    const esTercero = isTerceros || !!client.es_tercero;
    if (!esTercero) return;
    let tipoOpPadre = null;
    if (isTerceros) {
      tipoOpPadre = user?.cliente?.tipo_operacion || null;
    } else if (client.padre_id) {
      const emisor = (emisoresDisponibles || []).find(
        (em) => Number(em.id) === Number(client.padre_id)
      );
      tipoOpPadre = emisor ? (emisor.tipo_operacion || null) : null;
    }
    if (tipoOpPadre && tipoOpPadre !== client.tipo_operacion) {
      setClient((prev) => ({ ...prev, tipo_operacion: tipoOpPadre }));
    }
  }, [client?.padre_id, client?.es_tercero, isTerceros, emisoresDisponibles, user]);

  // (2026-08-02, ítem 18) Preselección del selector del Catálogo 7 al EDITAR:
  // se prioriza la fila ya guardada (nested `tipo_identificacion` o la FK) y, si
  // no hay ninguna (empresas anteriores a la migración), se resuelve por letra +
  // longitud igual que el backend. `_tipoIdentIdx` es UI-only.
  useEffect(() => {
    if (!client || tiposIdentificacion.length === 0) return;
    if (client._tipoIdentIdx !== undefined && client._tipoIdentIdx !== null) return;

    let idx = null;
    const nested = client.tipo_identificacion; // {id, codigo, descripcion, es_rif} | undefined
    if (nested && nested.id != null) {
      idx = tiposIdentificacion.findIndex((t) => t.id != null && Number(t.id) === Number(nested.id));
    }
    if ((idx == null || idx < 0) && client.tipo_identificacion_id != null) {
      idx = tiposIdentificacion.findIndex(
        (t) => t.id != null && Number(t.id) === Number(client.tipo_identificacion_id)
      );
    }
    if (idx == null || idx < 0) {
      const letra = String(client.rif || '').trim().toUpperCase().charAt(0);
      if (letra === 'V') {
        // Dos filas 'V': se discrimina por la cantidad de dígitos del RIF
        // compuesto (misma regla que servicios_compartidos:271-278).
        const quiereFirma = (contarDigitosDocumento(client.rif) === 9);
        idx = tiposIdentificacion.findIndex(
          (t) => String(t.codigo).toUpperCase() === 'V' && esFirmaPersonal(t.descripcion) === quiereFirma
        );
      } else if (/^[A-Z]$/.test(letra)) {
        idx = tiposIdentificacion.findIndex((t) => String(t.codigo).toUpperCase() === letra);
      }
    }
    if (idx != null && idx >= 0) {
      setClient((prev) => ({ ...prev, _tipoIdentIdx: idx }));
    }
  }, [client, tiposIdentificacion]);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  // (ítem 18) Fila del Catálogo 7 seleccionada (o null si no hay elección).
  const getTipoIdentSeleccionado = () => {
    const idx = client && client._tipoIdentIdx;
    if (idx === undefined || idx === null || idx === '') return null;
    return tiposIdentificacion[Number(idx)] || null;
  };

  // (ítem 20) ¿Este registro es un tercero? (ruta /terceros o checkbox).
  const esTerceroForm = () => isTerceros || !!(client && client.es_tercero);

  const validate = () => {
    const newErrors = {};
    var errorToast = [];
    if (!client.rif){
      newErrors.rif = "R.I.F. es obligatorio";
      errorToast.push("- R.I.F. es obligatorio");
    }
    // (2026-08-02, remediación FE-A P1-2) FORMATO del R.I.F. por el mismo
    // espejo que el resto de la validación: `validarFormatoRifCat7` con
    // contexto 'empresa'. Cambia respecto de `validateFormatRif` (legacy) en
    // dos puntos que importan:
    //   - Pasaporte: alfanumérico libre 1-20 (excepción del backend,
    //     client_routes.py:360-368; el legacy lo rechazaba siempre).
    //   - Comunal ('C'): admitida en EMPRESAS — empresa_routes NO usa
    //     validar_rif, solo coherencia de letra + longitud
    //     (servicios_compartidos.py:352-429). El legacy `[JVEGP]` la rechazaba.
    // Sin tipo elegido se conserva exactamente la regla histórica.
    if (client.rif){
      const _msgFormato = validarFormatoRifCat7(
        getTipoIdentSeleccionado(), client.rif, { contexto: 'empresa' }
      );
      if (_msgFormato){
        newErrors.rif = _msgFormato;
        errorToast.push(`- ${_msgFormato}`);
      }
    }
    if (!client.nombre_empresa){
      newErrors.nombre_empresa = "Razón social es obligatoria";
      errorToast.push("- Razón social es obligatoria");
    }
    if (!client.denominacion_comercial){
      newErrors.denominacion_comercial = "Denominacion comercial es obligatoria";
      errorToast.push("- Denominacion comercial es obligatoria");
    }
    if (!client.telefono){
      newErrors.telefono = "Teléfono es obligatorio";
      errorToast.push("- Teléfono es obligatorio");
    }
    if (client.telefono){
      if (!validateFormatPhone(client.telefono)){
        newErrors.telefono = "Teléfono no presenta un formato válido";
        errorToast.push("- Teléfono no presenta un formato válido");
      }
    }
    if (!client.email){
      newErrors.email = "Correo electrónico es obligatorio";
      errorToast.push("- Correo electrónico es obligatorio");
    }
    if (client.email){
      if (!validateFormatEmail(client.email)){
        newErrors.email = "Correo electrónico no presenta un formato válido";
        errorToast.push("- Correo electrónico no presenta un formato válido");
      }
    }
    if (!client.tipo_contribuyente_id){
      newErrors.tipo_contribuyente_id = "Tipo de contribuyente es obligatorio";
      errorToast.push("- Tipo de contribuyente es obligatorio");
    }
    if (!client.direccion){
      newErrors.direccion = "Dirección es obligatoria";
      errorToast.push("- Dirección es obligatoria");
    }
    if (!client.region || client.region == '#'){
      newErrors.region = "Región es obligatoria";
      errorToast.push("- Región es obligatoria");
    }
    console.log('client: ', client);
    if (!client.estado || client.estado == '#'){
      newErrors.estado = "Estado es obligatorio";
      errorToast.push("- Estado es obligatorio");
    }
    if (!client.zona){
      newErrors.zona = "Zona es obligatoria";
      errorToast.push("- Zona es obligatoria");
    }
    // (Increment 1C, Parte E/G) tipo_operacion obligatorio (espejo del backend).
    // (2026-08-02, ítem 20) Para un TERCERO el usuario ya NO lo elige: se hereda
    // del emisor. Deja de ser un campo obligatorio "de usuario", pero si la
    // herencia no pudo resolverse se BLOQUEA el envío con un mensaje explicativo
    // — el backend devolvería 400 igualmente (empresa_routes.py:402-409).
    if (esTerceroForm()){
      if (!client.tipo_operacion){
        const msgTO = isTerceros
          ? "No se pudo heredar el Modo de operación de su empresa emisora. "
            + "Cierre sesión y vuelva a iniciarla; si persiste, configure el Modo "
            + "de operación de la empresa emisora — el tercero lo hereda."
          : "El emisor seleccionado no tiene Modo de operación configurado. "
            + "Configúrelo en la ficha del emisor — el tercero lo hereda.";
        newErrors.tipo_operacion = msgTO;
        errorToast.push(`- ${msgTO}`);
      }
    } else if (!client.tipo_operacion){
      newErrors.tipo_operacion = "Modo de operación (tipo_operacion) es obligatorio";
      errorToast.push("- Modo de operación (tipo_operacion) es obligatorio");
    }

    // --- (2026-08-02, ítem 18) Tipo de identificación (Catálogo 7) ---
    // ESPEJO de servicios_compartidos.validar_tipo_identificacion_empresa
    // (servicios_compartidos.py:352-429), que el backend invoca desde
    // empresa_routes.py:190-193 en POST y PUT:
    //   (a) coherencia de la letra en AMBOS sentidos (es_rif true/false);
    //   (b) LONGITUD contando TODOS los dígitos del RIF COMPUESTO
    //       ('V-12345678-9' -> 9), que es lo que discrimina las dos filas 'V'.
    // El campo es OPCIONAL en el backend: sin elección no se valida nada.
    const tipoIdentSel = getTipoIdentSeleccionado();
    if (tipoIdentSel && client.rif) {
      const msgCoherencia = validarCoherenciaRifCat7(tipoIdentSel, client.rif);
      if (msgCoherencia) {
        newErrors.tipo_identificacion_id = msgCoherencia;
        errorToast.push(`- ${msgCoherencia}`);
      }
      const msgLongitud = validarLongitudCat7(tipoIdentSel, client.rif);
      if (msgLongitud && !newErrors.tipo_identificacion_id) {
        newErrors.tipo_identificacion_id = msgLongitud;
        errorToast.push(`- ${msgLongitud}`);
      }
    }
    // -----------------------------------------------------------------

    // --- Req 1 v6 (2026-05-13): validaciones de tercero ---
    // Si es_tercero=true, el padre_id es obligatorio. Y el emisor seleccionado
    // debe estar activo (la lista cargada en `emisoresDisponibles` ya viene
    // filtrada del backend con es_emisor=true, pero el activo no se filtraba
    // — agregamos check explícito).
    // (2026-05-15) En modo terceros el padre = cliente del usuario (su
    // emisor), asignado automáticamente y NO presente en
    // `emisoresDisponibles` (el backend lo excluye del dropdown). El backend
    // valida padre_id/es_emisor; aquí se omite el check de UI para no
    // bloquear con un falso "emisor no válido".
    if (client.es_tercero && !isTerceros) {
      if (!client.padre_id) {
        newErrors.padre_id = "Debe seleccionar el emisor (padre) del tercero";
        errorToast.push("- Debe seleccionar el emisor (padre) del tercero");
      } else {
        const padreSeleccionado = emisoresDisponibles.find(
          (em) => em.id === Number(client.padre_id)
        );
        if (!padreSeleccionado) {
          newErrors.padre_id = "El emisor seleccionado no es válido";
          errorToast.push("- El emisor seleccionado no es válido");
        } else if (padreSeleccionado.activo === false) {
          newErrors.padre_id = "El emisor seleccionado está inactivo";
          errorToast.push("- El emisor seleccionado está inactivo. Active el emisor antes de vincular terceros.");
        } else if (padreSeleccionado.es_emisor !== true) {
          newErrors.padre_id = "El cliente seleccionado no es emisor";
          errorToast.push("- El cliente seleccionado no tiene es_emisor=true");
        }
      }
    }
    // -------------------------------------------------------

    setErrors(newErrors);
    if (errorToast.length > 0){
      toast.error(<div>
        {errorToast.map(item => (
            <span className="text-start">{item}<br/></span>
          ))}
      </div>)
      setButtonDisabled(false);
    }
    return Object.keys(newErrors).length === 0;
  };

  // Req 1 v5: Helper para leer un File como string base64 (con prefijo data:...)
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí enviarías los datos de nuevo al backend para actualizar al client
    setButtonDisabled(true); // Iniciar carga (deshabilitar botón)
    // (2026-05-15) Si la validación falla, re-habilitar el botón (antes
    // quedaba deshabilitado para siempre y no se podía reintentar).
    if (!validate()) { setButtonDisabled(false); return; }
    // (remediación FE-A P1-4) Defensa en profundidad: aunque el botón esté
    // deshabilitado, cualquier otra vía de submit queda cortada aquí.
    if (correlativosBloqueo) {
      toast.error(correlativosBloqueo + " No se puede guardar todavía.", { autoClose: 6000 });
      setButtonDisabled(false);
      return;
    }
    console.log("Client:", client);
    try {
      var data;
      var message = '';
      const esCreacion = client.id == '#';
      // (2026-08-02, ítem 18) `_tipoIdentIdx` es UI-only (índice del selector):
      // NO debe viajar al backend. `tipo_identificacion` (objeto anidado del GET)
      // es dump_only y tampoco forma parte del contrato de escritura.
      const _base = { ...client };
      delete _base._tipoIdentIdx;
      delete _base.tipo_identificacion;
      if (esCreacion){
        delete _base.id;

        // Req 1 v5 (2026-05-13): si es tercero y hay archivo, leerlo como
        // base64 y adjuntar al payload. El backend lo persiste como
        // ContratoTercero en estado 'Pendiente' automáticamente.
        let payload = { ..._base };
        if (client.es_tercero && contratoFile) {
          try {
            const b64 = await fileToBase64(contratoFile);
            payload.contrato_file = b64;
            payload.contrato_filename = contratoFile.name;
            payload.contrato_content_type = contratoFile.type || 'application/pdf';
          } catch (err) {
            toast.error("Error al leer el archivo del contrato");
            setButtonDisabled(false);
            return;
          }
        }

        console.log("Client(F): ", { ...payload, contrato_file: payload.contrato_file ? '<base64 truncado>' : undefined });
        var clientList = [payload];
        data = await createClient(clientList); // Llamamos a createClient con el ID
        message = '!Creación de cliente realizada correctamente!';
      }else{
        data = await editClient(decryptText(clientId), _base); // Llamamos a editClient con el ID
        //console.log("Client(F)-editClient-data: ", data);
        //console.log("Client(F)-editClient-client: ", client);
        message = '!Actualización de cliente realizada correctamente!';
      }
      //console.log('editClient-data: ', data);
      setClient(data); // Guardamos los datos del client en el estado

      // (2026-05-22) Guardado UNIFICADO de correlativos fiscales: se
      // persisten junto con la empresa. Se hace después de crear/editar
      // para disponer del id real (en creación lo entrega el backend).
      let empresaIdGuardada = null;
      if (esCreacion) {
        empresaIdGuardada = Array.isArray(data)
          ? (data[0] && data[0].id) || null
          : (data && data.id) || null;
      } else {
        empresaIdGuardada = (data && data.id) || decryptText(clientId);
      }
      let correlativosError = null;
      if (empresaIdGuardada && correlativosRef.current) {
        try {
          await correlativosRef.current.guardar(empresaIdGuardada);
        } catch (corrErr) {
          correlativosError =
            corrErr?.response?.data?.error ||
            corrErr?.message ||
            "No se pudieron guardar los correlativos fiscales.";
        }
      }

      // (2026-05-25 v10) Redirect inteligente post-crear-empresa.
      // - Si es admin creando una empresa NUEVA y tenemos el id de la empresa
      //   creada → redirige al formulario de crear usuario inicial con el
      //   empresa_id precargado (query param). Esto cierra el bug de "olvidar
      //   vincular usuario a empresa nueva".
      // - Si es edición o no hay id → flow original (vuelve al listado).
      // (2026-08-05) Se retiró el guard `!isTerceros`: excluía a las empresas
      // TERCERAS del flujo de continuidad, así que tras crear una tercera se
      // volvía al listado y no había forma de llegar al alta de su usuario con
      // la empresa precargada. Los terceros SÍ tienen usuarios (es el camino
      // soportado para que operen por su cuenta), y el selector del formulario
      // de usuarios ya los lista.
      const debeRedirigirACrearUsuario =
        esCreacion
        && user?.rol === 'admin'
        && empresaIdGuardada
        && !correlativosError;

      const irALista = () => setTimeout(() => {
        navigate(isTerceros ? "/terceros" : "/empresas");
      }, 1500);

      const irACrearUsuario = () => setTimeout(() => {
        navigate(`/company-users/create?empresa_id=${empresaIdGuardada}`);
      }, 1800);

      if (correlativosError) {
        // La empresa SÍ se guardó; solo fallaron los correlativos.
        toast.error(
          message.replace(/!$/, "") +
          "\nPero los correlativos fiscales no se registraron: " +
          correlativosError + "\nEdite la empresa para reintentarlo.",
          { autoClose: 8000, onClose: irALista, style: { whiteSpace: "pre-line" } }
        );
      } else if (debeRedirigirACrearUsuario) {
        toast.success(
          message.replace(/!$/, "") +
          "\nA continuación, registre el usuario administrador inicial.",
          { autoClose: 2200, onClose: irACrearUsuario, style: { whiteSpace: "pre-line" } }
        );
      } else {
        toast.success(message, { onClose: irALista });
      }
    } catch (err) {
      // (2026-05-15) Mostrar el ERROR REAL del backend en la UI (antes se
      // tragaba con un genérico "Error al cargar el cliente" que además
      // destruía el formulario al hacer setError()). Ahora se conserva el
      // formulario y se muestra el mensaje exacto del servidor en un toast.
      const backendMsg =
        err?.response?.data?.error ||
        err?.response?.data?.detalle ||
        err?.response?.data?.message ||
        (Array.isArray(err?.response?.data)
          ? err.response.data.map((e) => e.error || e.message || JSON.stringify(e)).join("\n")
          : null) ||
        err?.message ||
        "No se pudo guardar el cliente. Intente nuevamente.";
      toast.error(backendMsg, { autoClose: 6000, style: { whiteSpace: "pre-line" } });
    } finally {
      setLoading(false); // Indicamos que la carga ha finalizado
      setButtonDisabled(false); // Re-habilitar el botón para reintentar
    }
  };

  const redirectToList = () => {
    navigate(isTerceros ? `/terceros` : `/empresas`);
  };

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Header */}
            <div class="rounded-t bg-white mb-0 px-6 py-6">
              <div class="text-center flex justify-between">
                <h6 class="text-blueGray-700 text-xl font-bold">{client.id == '#'? "Crear" : "Actualizar"} Empresa</h6>
              </div>
            </div>
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
              <h6 class="text-blueGray-400 text-sm mt-3 my-6 font-bold uppercase">Información del cliente</h6>
              <form onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>
                <hr class="my-6 border-b-1 border-blueGray-300"/>
                <div className="flex flex-wrap">
                  {/* (2026-08-02, ítem 18) Tipo de identificación (Catálogo 7)
                      ANTES del R.I.F.: es el campo que decide si el R.I.F. lleva
                      letra (es_rif=true) o es una cédula de 6-8 dígitos
                      (es_rif=false). El backend ya persiste y valida
                      `tipo_identificacion_id` en empresas (ítem 17). */}
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Tipo de identificación</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client._tipoIdentIdx != null ? client._tipoIdentIdx : ''}
                        onChange={(e) => {
                          const idx = e.target.value === '' ? null : Number(e.target.value);
                          const sel = idx != null ? tiposIdentificacion[idx] : null;
                          // Solo se ajusta la LETRA del R.I.F. (nunca los dígitos):
                          //   es_rif=true  -> se antepone/sustituye la letra del tipo.
                          //   es_rif=false -> se retira la letra (cédula sin letra).
                          let rifAjustado = client.rif || '';
                          if (sel) {
                            const letraTipo = String(sel.codigo || '').toUpperCase();
                            const bruto = String(rifAjustado).toUpperCase();
                            const primera = bruto.charAt(0);
                            if (sel.es_rif) {
                              if (bruto === '') rifAjustado = `${letraTipo}-`;
                              else if (/^[A-Z]$/.test(primera)) rifAjustado = letraTipo + bruto.slice(1);
                              else rifAjustado = `${letraTipo}-${bruto}`;
                            } else if (/^[A-Z]$/.test(primera)) {
                              rifAjustado = bruto.slice(1).replace(/-/g, '');
                            }
                          }
                          setClient({
                            ...client,
                            _tipoIdentIdx: idx,
                            tipo_identificacion_id: sel && sel.id != null ? sel.id : null,
                            rif: rifAjustado,
                          });
                        }}
                      >
                        <option value="">Seleccione...</option>
                        {tiposIdentificacion.map((t, idx) => (
                          <option key={`${t.codigo}-${t.id != null ? t.id : 'x'}-${idx}`} value={idx}>
                            {t.label}
                          </option>
                        ))}
                      </select>
                      {errors.tipo_identificacion_id && <p className="text-red-500 text-xs mt-1">{errors.tipo_identificacion_id}</p>}
                      <p className="text-xs text-blueGray-400 mt-1">
                        Persona natural: 6-8 dígitos, sin letra. Firma personal y J/E/G/C: 9 dígitos con la letra.
                      </p>
                      {catalogoAviso && (
                        <p className="text-xs text-amber-600 mt-1">
                          <i className="fas fa-triangle-exclamation mr-1" />
                          {catalogoAviso}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">RIF</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.rif} placeholder="V-12345678-9" onChange={(e) => {
                          let value = e.target.value.toUpperCase();

                          // Elimina caracteres no válidos (solo letras, números y guiones)
                          value = value.replace(/[^A-Z0-9-]/g, "");

                          // (remediación FE-A, P0) EXCEPCIÓN PASAPORTE: con el
                          // tipo 'P' elegido el documento es ALFANUMÉRICO libre
                          // (1-20) — el backend no le aplica validar_rif
                          // (client_routes.py:360-368) y para empresas tampoco.
                          // Sin esta rama el input impedía teclear letras y el
                          // pasaporte era inconstruible.
                          const _tipoRif = getTipoIdentSeleccionado();
                          if (_tipoRif && String(_tipoRif.codigo).toUpperCase() === 'P') {
                            let cuerpo = value.startsWith('P-') ? value.slice(2)
                                       : (value.charAt(0) === 'P' ? value.slice(1) : value);
                            cuerpo = cuerpo.replace(/^-+/, '');
                            setClient({ ...client, rif: `P-${cuerpo}`.slice(0, 22) });
                            return;
                          }

                          // (remediación FE-A, P1-3b) 'C' (Comunal) admitida en
                          // EMPRESAS: empresa_routes NO usa validar_rif, solo
                          // coherencia de letra + longitud.
                          // (2026-08-03, ronda 2 / T1) También en CLIENTES:
                          // `utils.validar_rif` ya incluye la letra en su clase
                          // (`^[VEJGPC]-\d{8}-\d$`, utils.py:351) por decisión
                          // del usuario, así que la asimetría desapareció y
                          // estas clases quedan iguales en ambos formularios.
                          // Forzar el patrón paso a paso
                          if (value.length === 1) {
                            // Primera posición → solo letras válidas
                            if (!/[VJEPGC123456789]/.test(value)) value = "";
                          } else if (value.length === 2) {
                              // Solo agregar guion si comienza con letra válida
                              if (/[VJEPGC]/.test(value[0]) && /[1234567890]/.test(value[1]) && !value.includes("-")) {
                                if (/[VJEPGC1234567890-]/.test(value[1])){
                                  value = value[0] + "-" + value[1];
                                }else{
                                  value = value[0];
                                }
                              }else if (!/[1234567890]/.test(value)) {
                                value = value[0];
                              }
                            } else if (value.length > 2) {
                            // Nuevo: permitir solo números (hasta 8)
                            const matchSoloNumeros = value.match(/^\d{0,8}$/);

                            if (matchSoloNumeros) {
                              value = matchSoloNumeros[0];
                            } else {
                              // Caso RIF tradicional
                              const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);
                              if (match) {
                                const [, letra, numeros, verificador] = match;
                                value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
                              } else {
                                value = client.rif;
                              }
                            }
                          }

                          setClient({ ...client, rif: value });
                        }}
                      />
                      {errors.rif && <p className="text-red-500 text-xs mt-1">{errors.rif}</p>}
                    </div>
                  </div>
                  {/* (ítem 18) Rebalanceo del grid de 12 columnas: el selector de
                      tipo de identificación (3) + RIF (2) + Razón social (6) + el
                      hueco del logo (1). */}
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Razón social</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.nombre_empresa}
                        placeholder="Nombre de la empresa"
                        onChange={(e) => setClient({ ...client, nombre_empresa: e.target.value.toUpperCase() })}
                      />
                      {errors.nombre_empresa && <p className="text-red-500 text-xs mt-1">{errors.nombre_empresa}</p>}
                      </div>
                  </div>
                  <div className="w-full lg:w-1/12 px-4">

                  </div>
                  <div className="w-full lg:w-11/12 px-4">
                    <div className="relative w-full mb-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">Denominación comercial</label>
                        <input
                          type="text"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          value={client.denominacion_comercial}
                          placeholder="Denominación comercial"
                          onChange={(e) => setClient({ ...client, denominacion_comercial: e.target.value.toUpperCase() })}
                        />
                        {errors.denominacion_comercial && <p className="text-red-500 text-xs mt-1">{errors.denominacion_comercial}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-1/12 px-4">
                    <div className="relative w-full mb-3">
                      <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2">
                          <div className="w-24 h-24 border-4 border-white shadow-lg overflow-hidden bg-gray-200">
                              <LogoUploader
                                logo={client.logo}
                                onChange={(base64) => setClient({ ...client, logo: base64 })}
                                size={24} //24, 32, 48
                                mode="edit"
                              />
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Teléfono</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.telefono}
                        placeholder="0000-0000000"
                        onChange={(e) => {
                          let value = e.target.value;
                          // Eliminar todo lo que no sea número
                          value = value.replace(/\D/g, "");

                          // Limitar a máximo 11 dígitos (4 + 7)
                          value = value.slice(0, 11);

                          // Insertar guion después de los primeros 4 dígitos
                          if (value.length > 4) {
                            value = value.slice(0, 4) + "-" + value.slice(4);
                          }
                          setClient({ ...client, telefono: value });
                        }}
                      />
                      {errors.telefono && <p className="text-red-500 text-xs mt-1">{errors.telefono}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-5/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correo electrónico</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.email}
                        placeholder="correo@correo.com"
                        onChange={(e) => setClient({ ...client, email: e.target.value.toUpperCase() })}
                      />
                      {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Tipo de contribuyente</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.tipo_contribuyente_id}
                        onChange={(e) => setClient({ ...client, tipo_contribuyente_id: e.target.value })}
                      >
                        {typeTaxpayer.length > 0 ? (
                            typeTaxpayer.map(taxpayer => (
                            <option key={taxpayer.id} value={taxpayer.id}>{taxpayer.nombre}</option>
                          ))
                        ) : (
                          <option value="0">Seleccione...</option>
                        )}
                      </select>
                      {errors.tipo_contribuyente_id && <p className="text-red-500 text-xs mt-1">{errors.tipo_contribuyente_id}</p>}
                    </div>
                  </div>
                  {/* (Increment 1C, Parte E/G) Modo de operación de la numeración fiscal */}
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Modo de operación (numeración)</label>
                      {/* (2026-08-02, ítem 20) Para un TERCERO el modo se HEREDA
                          del emisor y el campo se DESACTIVA: el backend lo fuerza
                          e ignora lo que envíe el frontend
                          (empresa_routes.py:394-410). Mismo patrón que el
                          selector de moneda extranjera heredada. */}
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 disabled:bg-slate-100 disabled:cursor-not-allowed"
                        value={client.tipo_operacion || ""}
                        disabled={esTerceroForm()}
                        onChange={(e) => setClient({ ...client, tipo_operacion: e.target.value })}
                      >
                        <option value="">Seleccione...</option>
                        <option value="NumeracionAutomatica">Numeración automática (el sistema asigna)</option>
                        <option value="ValidacionDocumento">Validación de documento (número del ERP)</option>
                      </select>
                      {esTerceroForm() && (
                        <p className="text-xs text-blueGray-400 mt-1">
                          <span className="text-amber-600">
                            <i className="fas fa-lock mr-1" />
                            Se hereda obligatoriamente el Modo de operación de su empresa emisora.
                          </span>
                        </p>
                      )}
                      {errors.tipo_operacion && <p className="text-red-500 text-xs mt-1">{errors.tipo_operacion}</p>}
                    </div>
                  </div>

                  {/* --- Req 2 (2026-05-13): Configuración multi-moneda --- */}
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Moneda designada
                      </label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.moneda_designada_id || 3}
                        onChange={(e) => setClient({ ...client, moneda_designada_id: Number(e.target.value) })}
                      >
                        {monedas.map(m => (
                          <option key={m.id} value={m.id}>{m.codigo} — {m.nombre}</option>
                        ))}
                      </select>
                      <p className="text-xs text-blueGray-400 mt-1">
                        Moneda en la que el cliente factura por defecto.
                      </p>
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Moneda extranjera
                      </label>
                      {/* (2026-05-13) Req 2: si el cliente ya emitio facturas
                          (backend expone has_facturas en el detalle), el campo
                          queda inmutable para preservar la integridad historica
                          de los totales _extranjero de facturas anteriores. */}
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 disabled:bg-slate-100 disabled:cursor-not-allowed"
                        value={client.moneda_extranjera_id || 1}
                        // (2026-05-22) Deshabilitado tambien para CUALQUIER
                        // tercero (isTerceros = ruta /terceros; client.es_tercero
                        // = admin marcando "Es tercero" en /empresas). El
                        // tercero hereda la moneda extranjera de su emisor.
                        disabled={!!client.has_facturas || isTerceros || !!client.es_tercero}
                        onChange={(e) => setClient({ ...client, moneda_extranjera_id: Number(e.target.value) })}
                      >
                        {monedas.map(m => (
                          <option key={m.id} value={m.id}>{m.codigo} — {m.nombre}</option>
                        ))}
                      </select>
                      <p className="text-xs text-blueGray-400 mt-1">
                        {(isTerceros || client.es_tercero) ? (
                          <span className="text-amber-600">
                            <i className="fas fa-lock mr-1" />
                            Se hereda obligatoriamente la moneda extranjera de su empresa emisora.
                          </span>
                        ) : client.has_facturas ? (
                          <span className="text-amber-600">
                            <i className="fas fa-lock mr-1" />
                            Bloqueado: el cliente ya emitió facturas. Cambiarlo afectaría la conversión histórica.
                          </span>
                        ) : (
                          "Para dashboards y conversión de precios."
                        )}
                      </p>
                    </div>
                  </div>

                  {/* (2026-06-10) Regla de costo (Compras): define cómo se
                      actualiza el campo `costo` de los productos de esta
                      empresa al registrar una compra que los vincule.
                      Cambiarla reinicia el acumulado del promedio (backend).
                      (2026-08-05) Movida FUERA del recuadro «Facturación de
                      Terceros» y por delante de él: es una regla de Compras de
                      la propia empresa, no tiene relación con los terceros. */}
                  <div className="w-full px-4 mt-3">
                    <div className="flex flex-wrap gap-4">
                      <div className="flex-1 min-w-[260px]">
                        <label className="block text-blueGray-600 text-xs font-bold mb-1">
                          Regla de costo (Compras)
                        </label>
                        <select
                          className="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow w-full"
                          value={client.regla_costo || 'ultimo'}
                          onChange={(e) => setClient({ ...client, regla_costo: e.target.value })}
                        >
                          <option value="ultimo">Último costo (sobrescribe con la última compra)</option>
                          <option value="promedio_ponderado">Costo promedio ponderado</option>
                        </select>
                        <p className="text-xs text-slate-500 mt-1">
                          Cómo se actualiza el costo de los productos al registrar compras. Cambiarla reinicia el acumulado del promedio.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* --- Req 1 (2026-05-13): Facturación de terceros --- */}
                  <div className="w-full px-4 mt-3">
                    <div className="bg-twilight-indigo-50 border border-twilight-indigo-200 rounded p-3">
                      <h6 className="text-twilight-indigo-700 text-xs uppercase font-bold mb-2">
                        Facturación de Terceros
                      </h6>
                      {isTerceros ? (
                        <p className="text-xs text-twilight-indigo-700">
                          <i className="fas fa-user-friends mr-1" />
                          Este registro se crea como <b>tercero</b> vinculado a su empresa emisora.
                        </p>
                      ) : (
                      <div className="flex flex-wrap gap-4 items-end">
                        <label className="inline-flex items-center text-sm">
                          <input
                            type="checkbox"
                            className="form-checkbox mr-2"
                            checked={!!client.es_emisor}
                            onChange={(e) => setClient({
                              ...client,
                              es_emisor: e.target.checked,
                              // Mutuamente excluyentes
                              es_tercero: e.target.checked ? false : client.es_tercero,
                              padre_id: e.target.checked ? null : client.padre_id,
                            })}
                          />
                          <span className="font-bold">Es emisor</span>
                          <span className="ml-1 text-xs text-slate-500">
                            (puede emitir facturas a nombre de terceros)
                          </span>
                        </label>
                        <label className="inline-flex items-center text-sm">
                          <input
                            type="checkbox"
                            className="form-checkbox mr-2"
                            checked={!!client.es_tercero}
                            onChange={(e) => setClient({
                              ...client,
                              es_tercero: e.target.checked,
                              es_emisor: e.target.checked ? false : client.es_emisor,
                            })}
                          />
                          <span className="font-bold">Es tercero</span>
                          <span className="ml-1 text-xs text-slate-500">
                            (afiliado a un emisor; nace inactivo)
                          </span>
                        </label>
                      </div>
                      )}

                      {/* (2026-05-20) Regla de facturación de terceros — solo
                          visible cuando es_emisor=true. Condiciona si las
                          facturas de tercero se emiten Separada (2 facturas:
                          principal + comisión) o Combinada (1 factura con la
                          comisión como línea adicional). */}
                      {client.es_emisor && (
                        <div className="flex flex-wrap gap-4 mt-3">
                          <div className="flex-1 min-w-[260px]">
                            <label className="block text-blueGray-600 text-xs font-bold mb-1">
                              Regla de facturación de terceros
                            </label>
                            <select
                              className="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow w-full"
                              value={client.regla_facturacion || 'Separada'}
                              onChange={(e) => setClient({ ...client, regla_facturacion: e.target.value })}
                            >
                              <option value="Separada">Separada (2 facturas: principal + comisión)</option>
                              <option value="Combinada">Combinada (1 factura con comisión como línea)</option>
                            </select>
                            <p className="text-xs text-slate-500 mt-1">
                              Aplica solo al emitir facturas con tercero (<code>doc_tercero=true</code>).
                            </p>
                          </div>
                        </div>
                      )}

                      {client.es_tercero && (
                        <div className="flex flex-wrap gap-4 mt-3">
                          {!isTerceros && (
                          <div className="flex-1 min-w-[200px]">
                            <label className="block text-blueGray-600 text-xs font-bold mb-1">
                              Emisor (padre) *
                            </label>
                            {/* (2026-08-02, ítem 21) Buscador: MUI Autocomplete
                                (patrón FormWithholdings.js:803-824). El listado
                                ya NO llega truncado a 20 filas — ver el fix de
                                paginación en services/api_clients.getClients. */}
                            {(() => {
                              const opcionesEmisores = (emisoresDisponibles || [])
                                .filter((em) => em.id !== ownClienteId)
                                // Req 1 v6 (2026-05-13): solo emisores activos.
                                // Un emisor inactivo no puede tener nuevos
                                // terceros vinculados.
                                .filter((em) => em.activo !== false);
                              return (
                                <Autocomplete
                                  options={opcionesEmisores}
                                  size="small"
                                  getOptionLabel={(option) => {
                                    // (remediación "sin IDs visibles") El fallback
                                    // anterior mostraba el id técnico ('ID ' +
                                    // option.id) cuando faltaba nombre_empresa. Se
                                    // reemplaza por el RIF (identificador de
                                    // negocio) o un rótulo genérico — nunca la
                                    // clave primaria.
                                    const base = option.nombre_empresa || option.rif || 'Empresa sin nombre';
                                    const mostrarRif = option.rif && option.nombre_empresa;
                                    return `${base}${mostrarRif ? ` (${option.rif})` : ''}`;
                                  }}
                                  isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                                  value={opcionesEmisores.find((em) => Number(em.id) === Number(client.padre_id)) || null}
                                  onChange={(e, newValue) => setClient({
                                    ...client,
                                    padre_id: newValue ? Number(newValue.id) : null,
                                  })}
                                  renderInput={(paramsInput) => (
                                    <TextField
                                      {...paramsInput}
                                      variant="standard"
                                      placeholder="Busque y seleccione el emisor..."
                                      fullWidth
                                    />
                                  )}
                                />
                              );
                            })()}
                            {errors.padre_id && <p className="text-red-500 text-xs mt-1">{errors.padre_id}</p>}
                          </div>
                          )}
                          {/* Req 1 v3 (2026-05-13): el campo comision_servicio se
                              ingresa al aprobar el contrato del tercero, no al
                              crearlo. Default 0.00, se actualiza vía Contratos. */}
                          <div className="flex-1 min-w-[160px]">
                            <label className="block text-blueGray-600 text-xs font-bold mb-1">
                              Comisión servicio (%)
                            </label>
                            <div className="border-0 px-3 py-2 bg-slate-100 text-slate-500 rounded text-sm shadow w-full italic">
                              {client.comision_servicio != null ? `${client.comision_servicio}%` : '0.00% (sin contrato aprobado)'}
                            </div>
                            <p className="text-[10px] text-slate-500 mt-1">
                              <i className="fas fa-lock mr-1" />
                              Se establece al aprobar el contrato (módulo "Contratos de Terceros").
                            </p>
                          </div>
                        </div>
                      )}

                      {/* Req 1 v5 (2026-05-13): contrato adjunto opcional al crear */}
                      {client.es_tercero && client.id === '#' && (
                        <div className="mt-3 border-t border-twilight-indigo-100 pt-3">
                          <label className="block text-blueGray-600 text-xs font-bold mb-1">
                            <i className="fas fa-paperclip mr-1" />
                            Adjuntar contrato (opcional, PDF / imagen, máx. 10 MB)
                          </label>
                          <input
                            type="file"
                            accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                            className="text-sm"
                            onChange={(e) => setContratoFile(e.target.files[0] || null)}
                          />
                          {contratoFile && (
                            <p className="text-[10px] text-slate-600 mt-1">
                              <i className="fas fa-check-circle text-emerald-500 mr-1" />
                              {contratoFile.name} — {Math.round(contratoFile.size / 1024)} KB
                              <button
                                type="button"
                                className="ml-2 text-red-500 hover:underline"
                                onClick={() => setContratoFile(null)}
                              >
                                Quitar
                              </button>
                            </p>
                          )}
                          <p className="text-[10px] text-slate-500 mt-1">
                            Si adjunta un contrato aquí, el sistema lo registrará en
                            estado <strong>Pendiente</strong> automáticamente. Caso
                            contrario podrá subirlo desde "Contratos de Terceros"
                            después de crear el cliente.
                          </p>
                        </div>
                      )}

                      {client.es_tercero && (
                        <p className="mt-2 text-xs text-amber-700">
                          <i className="fas fa-info-circle mr-1" />
                          Un tercero nace <strong>Inactivo</strong> con comisión 0.00.
                          Para activarlo, suba un contrato, ingrese la comisión al
                          aprobarlo y la activación se habilitará automáticamente.
                        </p>
                      )}
                    </div>
                  </div>
                  {/* --- Fin Req 1 --- */}

                  {/* --- (2026-07-22 Viajes) Agencia de viajes / boletería aérea ---
                      D1 nivel 1: `es_agencia_viajes` HABILITA el nodo `/viajes`
                      del documento electrónico para esta empresa. NO obliga por
                      sí solo: la exigencia de los 15 campos la dispara el
                      indicador POR DOCUMENTO `es_boleteria_aerea` en la
                      proforma. Sin esta marca, la sección de boletos NO aparece
                      en el formulario de proformas y el backend rechaza (400)
                      cualquier documento con datos de viaje. */}
                  <div className="w-full px-4 mt-3">
                    <div className="bg-twilight-indigo-50 border border-twilight-indigo-200 rounded p-3">
                      <h6 className="text-twilight-indigo-700 text-xs uppercase font-bold mb-2">
                        Agencia de Viajes (Boletería Aérea)
                      </h6>
                      <div className="flex flex-wrap gap-4 items-end">
                        <label className="inline-flex items-center text-sm">
                          <input
                            type="checkbox"
                            className="form-checkbox mr-2"
                            checked={!!client.es_agencia_viajes}
                            onChange={(e) => setClient({
                              ...client,
                              es_agencia_viajes: e.target.checked,
                            })}
                          />
                          <span className="font-bold">Es agencia de viajes</span>
                          <span className="ml-1 text-xs text-slate-500">
                            (habilita los datos de pasajero y boleto en sus documentos)
                          </span>
                        </label>
                      </div>
                      <p className="mt-2 text-xs text-slate-500">
                        <i className="fas fa-info-circle mr-1" />
                        Al activarlo, cada proforma de esta empresa podrá marcarse como
                        <strong> boletería aérea</strong> y cargar uno o más boletos. Con la
                        marca de boletería activa, los 15 datos del viaje son obligatorios.
                      </p>
                    </div>
                  </div>
                  {/* --- Fin Viajes --- */}

                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Dirección</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.direccion}
                        placeholder="Calle, Avenida, Torre y/o Edificio"
                        onChange={(e) => setClient({ ...client, direccion: e.target.value.toUpperCase() })}
                      />
                      {errors.direccion && <p className="text-red-500 text-xs mt-1">{errors.direccion}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Región</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.region} onChange={(e) => {
                          const selectedOption = e.target.options[e.target.selectedIndex];
                          const regionId = selectedOption.getAttribute("region_id"); // obtienes el atributo
                          const regionValue = e.target.value; // obtienes el value normal
                          console.log("region_id:", regionId);
                          console.log("region value:", regionValue);
                          $('.region_id').addClass('hidden');
                          if (regionId){
                            $('.region_' + regionId.toString()).removeClass('hidden');
                          }
                          client.estado = '#';
                          // actualizamos el estado con ambos si quieres
                          setClient({ ...client, region: e.target.value });
                        }}>
                        <option value="#">Seleccione...</option>
                        <option region_id="1" value="Central">Central</option>
                        <option region_id="2" value="Capital">Capital</option>
                        <option region_id="3" value="Occidental">Occidental</option>
                        <option region_id="4" value="Guayana">Guayana</option>
                        <option region_id="5" value="Insular">Insular</option>
                        <option region_id="6" value="Los Andes">Los Andes</option>
                        <option region_id="7" value="Los Llanos">Los Llanos</option>
                        <option region_id="8" value="Oriental">Oriental</option>
                        <option region_id="9" value="Zuliana">Zuliana</option>
                      </select>
                      {errors.region && <p className="text-red-500 text-xs mt-1">{errors.region}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Estado</label>
                      <select id="select_state"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.estado} onChange={(e) => setClient({ ...client, estado: e.target.value })}>
                        <option value="#">Seleccione...</option>
                        <option class="region_id region_1" value="Aragua">Aragua</option>
                        <option class="region_id region_1" value="Carabobo">Carabobo</option>
                        <option class="region_id region_1" value="Cojedes">Cojedes</option>
                        <option class="region_id region_2" value="Distrito Capital">Distrito Capital</option>
                        <option class="region_id region_2" value="Miranda">Miranda</option>
                        <option class="region_id region_2" value="La Guaira">La Guaira</option>
                        <option class="region_id region_3" value="Falcón">Falcón</option>
                        <option class="region_id region_3" value="Lara">Lara</option>
                        <option class="region_id region_3" value="Portuguesa">Portuguesa</option>
                        <option class="region_id region_3" value="Yaracuy">Yaracuy</option>
                        <option class="region_id region_4" value="Amazonas">Amazonas</option>
                        <option class="region_id region_4" value="Bolívar">Bolívar</option>
                        <option class="region_id region_4" value="Delta Amacuro">Delta Amacuro</option>
                        <option class="region_id region_4" value="Guayana Esequiba">Guayana Esequiba</option>
                        <option class="region_id region_5" value="Dependencias Federales">Dependencias Federales</option>
                        <option class="region_id region_5" value="Nueva Esparta">Nueva Esparta</option>
                        <option class="region_id region_6" value="Barinas">Barinas</option>
                        <option class="region_id region_6" value="Mérida">Mérida</option>
                        <option class="region_id region_6" value="Táchira">Táchira</option>
                        <option class="region_id region_6" value="Trujillo">Trujillo</option>
                        <option class="region_id region_6" value="Apure - Municipio Páez">Apure - Municipio Páez</option>
                        <option class="region_id region_7" value="Apure - Sin el Municipio Páez">Apure - Sin el Municipio Páez</option>
                        <option class="region_id region_7" value="Guárico">Guárico</option>
                        <option class="region_id region_8" value="Anzoátegui">Anzoátegui</option>
                        <option class="region_id region_8" value="Monagas">Monagas</option>
                        <option class="region_id region_8" value="Sucre">Sucre</option>
                        <option class="region_id region_9" value="Zulia">Zulia</option>
                      </select>
                      {errors.estado && <p className="text-red-500 text-xs mt-1">{errors.estado}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Zona</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.zona}
                        onChange={(e) => setClient({ ...client, zona: e.target.value.toUpperCase() })}
                      />
                      {errors.zona && <p className="text-red-500 text-xs mt-1">{errors.zona}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Condición</label>
                      <div className="py-2">
                        {(client.activo == true) ? (
                          <span className="bg-emerald-400 text-white py-1 px-3 rounded-full text-xs font-bold whitespace-nowrap">
                            <i className="fas fa-circle mr-1" />Activo
                          </span>
                        ) : (
                          <span className="bg-red-400 text-white py-1 px-3 rounded-full text-xs font-bold whitespace-nowrap">
                            <i className="fas fa-circle mr-1" />Inactivo
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* (2026-05-22) Correlativos fiscales (correlativos_sistema)
                    — visible al CREAR y al EDITAR. No aplica a terceros
                    (facturan a través de su emisor) y solo lo ven/guardan
                    admin / operador_admin. El guardado va unificado con el
                    botón Guardar/Actualizar de la empresa (correlativosRef). */}
                {!isTerceros &&
                  (user?.rol === 'admin' || user?.rol === 'operador_admin') && (
                    <CorrelativosFiscales
                      ref={correlativosRef}
                      empresaId={client.id && client.id !== '#' ? client.id : null}
                      onBloqueoChange={(bloqueado, motivo) =>
                        setCorrelativosBloqueo(bloqueado ? motivo : null)
                      }
                    />
                )}
                {/* (remediación FE-A P1-4) Mientras los correlativos no se
                    puedan guardar con seguridad, el envío queda bloqueado y se
                    explica por qué. */}
                {correlativosBloqueo && (
                  <div className="w-full px-4">
                    <p className="text-xs text-amber-700 bg-amber-50 border border-amber-300 rounded p-2">
                      <i className="fas fa-hourglass-half mr-1" />
                      {correlativosBloqueo} No se puede guardar la empresa hasta
                      que los correlativos fiscales estén disponibles.
                    </p>
                  </div>
                )}
                <div className={FORM_FOOTER_CONTAINER}>
                  <button
                    type="button"
                    className={FORM_BTN_CANCEL}
                    disabled={buttonDisabled}
                    onClick={() => redirectToList()}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className={FORM_BTN_SUBMIT}
                    disabled={buttonDisabled || !!correlativosBloqueo}
                  >
                    {buttonDisabled
                      ? (client.id == '#' ? "Guardando..." : "Actualizando...")
                      : (client.id == '#' ? "Guardar" : "Actualizar")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormClients;